<template>
    <div  class="row">
        <div class="col-md-9">
            <div v-if="slug=='homepage'" class="intro">
                <h2>Check out our bestsellers</h2>
            </div>
            <product v-for="product in products" v-bind:product-item="product" v-bind:key="product.code" />
        </div>
        <basket />
    </div>
</template>
<script>
    import Product from './Product.vue'
    import Basket from './Basket.vue'
    import axios from '../lib/McAxios'

    export default {
        name: 'list',
        data: function () {
            return {
                products: [],
                slug: '',
            }
        },
        components: {
            Product,
            Basket
        },
        watch:{
            '$route.params': {
                handler: function(newValue) {
                    console.log(newValue)
                    this.slug = 'homepage'
                    if (typeof newValue.taxon != 'undefined' && newValue.taxon.length>0) {
                        this.slug = newValue.taxon.replace('_','/')
                    }
                    axios
                        .get('/shop-api/taxon-products/by-slug/'+this.slug, {
                            params: {
                                limit: 50
                            }
                        })
                        .then(response => {
                            this.products = response.data.items
                        })
                },
                deep: true,
                immediate: true
            }
        }
    }
</script>